module.exports = __webpack_public_path__ + "static/media/app-background.dd3e41c0.svg";